<template>
  <v-container class="account-container">
    <v-card class="mb-6 account-card" elevation="2">
      <v-card-title class="primary-header">
        <v-icon class="mr-2" dark>mdi-account</v-icon>
        User Details
      </v-card-title>

      <v-card-text style="margin-top: 15px;">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="details.line_number" label="Username" disabled outlined dense hide-details="auto"
              class="mb-4 font-weight-bold" bg-color="grey lighten-4"></v-text-field>

            <v-text-field v-model="details.owner_details.business_name" label="Organization/Business Name" outlined
              dense hide-details="auto" class="mb-4" :rules="[v => !!v || 'Required field']" required></v-text-field>

            <v-text-field v-model="details.owner_details.business_id" label="ID / Business ID" outlined dense
              hide-details="auto" class="mb-4" :rules="[v => !!v || 'Required field']" required></v-text-field>

            <v-text-field v-model="details.owner_details.name" label="Contact Person Name" outlined dense
              hide-details="auto" class="mb-4" :rules="[v => !!v || 'Required field']" required></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="details.owner_details.phone" label="Phone" type="number" hide-spin-buttons outlined
              dense hide-details="auto" class="mb-4" :rules="[v => !!v || 'Required field']" required></v-text-field>

            <v-autocomplete :items="coutryCodes" v-model="details.owner_details.callerid_country_code" item-text="he"
              item-value="en" label="Caller ID Verification" outlined dense hide-details="auto" class="mb-4"
              :rules="[v => !!v || 'Required field']" required></v-autocomplete>

            <v-text-field v-model="details.owner_details.email" label="Email" outlined dense hide-details="auto"
              class="mb-4"></v-text-field>

            <v-text-field v-model="details.owner_details.address" label="Address" outlined dense
              hide-details="auto"></v-text-field>
          </v-col>


          <v-col cols="12" md="6">
            <v-text-field v-model="details.owner_details.created_phone" label="Created By" disabled outlined dense
              hide-details="auto" class="mb-4 font-weight-bold" bg-color="grey lighten-4"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select v-model="details.owner_details.save_last_listen_policy" :items="saveLastListenPolicyOptions"
              label="Save Last Listening Position" item-text="text" item-value="value"
              :rules="[v => !!v || 'Required field']" dense outlined />
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-6 account-card" elevation="2">
      <v-card-title class="secondary-header">
        <v-icon class="mr-2">mdi-lock</v-icon>
        Passwords & Access
      </v-card-title>

      <v-card-text style="margin-top: 15px;">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="details.phone_password" label="Phone Password" maxlength="6" hide-spin-buttons
              outlined dense hide-details="auto" class="mb-4" :rules="[v => !!v || 'Required field']"
              required></v-text-field>

            <v-text-field v-model="details.api_token" label="API Token" disabled outlined dense hide-details="auto"
              class="mb-4" bg-color="grey lighten-4"></v-text-field>
          </v-col>

          <v-col cols="12" md="6">

            <v-text-field v-model="passObj.password" label="Admin Panel Password" type="password" outlined dense
              hide-details="auto" class="mb-4"></v-text-field>

            <v-text-field v-model="passObj.repeat_password" label="Confirm Password" type="password" outlined dense
              hide-details="auto" class="mb-4" :rules="[
                v => !passObj.password || !!v || 'Please confirm the password',
                v => v === passObj.password || 'Passwords do not match'
              ]"></v-text-field>


          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Security Card -->
    <v-card class="mb-6 account-card" elevation="2">
      <v-card-title class="security-header">
        <v-icon class="mr-2">mdi-shield-lock</v-icon>
        Security
      </v-card-title>

      <v-card-text style="margin-top: 15px;">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field v-model="details.owner_details.allowed_ip" label="Fixed IP Address (No Two-Factor Auth)"
              outlined dense hide-details="auto" class="mb-1" placeholder="e.g. 192.168.1.1"
              prepend-icon="mdi-ip-network"></v-text-field>
            <div class="ip-hint">
              This IP address will have direct access to the system without requiring two-factor authentication
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div class="d-flex justify-end mb-8">
      <v-btn color="primary" x-large :loading="progressShow" :disabled="progressShow" @click="saveChanges"
        class="save-button">
        <v-icon left>mdi-content-save</v-icon>
        Save Changes
      </v-btn>
    </div>

    <v-overlay :value="progressShow" absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import Auth from '@/services/auth.service.js'
import sharedFunctions from '@/shared/sharedFunctions';

export default {
  components: {
    SnackBar,
  },
  data: () => ({
    snackbar: false,
    snackbarColorBt: "success",
    snacbarText: "",
    lineNumber: "",
    progressShow: false,
    details: {
      owner_details: {
        name: "",
        business_name: "",
        phone: "",
        callerid_country_code: "IL",
        address: "",
        business_id: "",
        email: "",
        save_last_listen_policy: "hangup_only",
        allowed_ip: "",
      },
      line_number: "",
      phone_password: "",
      api_token: "",
    },
    passObj: {
      password: "",
      repeat_password: "",
    },
    coutryCodes: [],
    saveLastListenPolicyOptions: [
      {
        text: "Only on hangup",
        value: "hangup_only",
      },
      {
        text: "Always",
        value: "always",
      },
    ],
  }),
  methods: {
    async getAccountDetails() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/account/get_account_details`;
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const jsonObject = await res.json();

        if (res.status >= 400) {
          this.showSnackBar("Error fetching data", "error");
        } else if (res.status === 200) {
          this.details = jsonObject;
        }
      } catch (error) {
        this.showSnackBar("Error get files: " + error, "error");
      } finally {
        this.progressShow = false;
      }
    },

    async saveChanges() {
      try {
        if (this.passObj.password) {
          if (this.passObj.password !== this.passObj.repeat_password) {
            return this.showSnackBar("Please confirm the new password", "error");
          }

          if (this.passObj.password.length < 9 || this.passObj.password.length > 20) {
            return this.showSnackBar("Password must contain between 9 and 20 characters", "error");
          }
        }

        if (this.details.phone_password.length < 4 || this.details.phone_password.length > 6) {
          return this.showSnackBar("Phone password must contain between 4 and 6 characters", "error");
        }

        this.progressShow = true;
        const detailsJSON = JSON.stringify({ details: this.details, passObj: this.passObj });
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/account/save_changes`;
        const res = await fetch(api, ApiServices.requestOptions("PUT", detailsJSON, token));
        const jsonObject = await res.json();

        if (res.status >= 400) {
          this.showSnackBar("Error saving changes: " + jsonObject.message, "error");
        } else if (res.status === 200) {
          this.showSnackBar("Changes updated successfully!", "success");
          // Reset password fields after successful update
          this.passObj.password = "";
          this.passObj.repeat_password = "";
        }
      } catch (error) {
        this.showSnackBar("Error get files: " + error, "error");
      } finally {
        this.progressShow = false;
      }
    },

    async getCountryCodes() {
      this.coutryCodes = await sharedFunctions.getCountryCodes();
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
  },

  mounted() {
    this.getCountryCodes();
    this.lineNumber = Auth.getLineNumber();
    this.getAccountDetails();
  },
}
</script>

<style scoped>
.account-container {
  max-width: 1200px;
  margin: 0 auto;
  direction: ltr;
  /* Changed from rtl to ltr */
  font-family: 'Heebo', sans-serif;
}

.account-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.account-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.primary-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.secondary-header {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%);
  color: #0d2c6d;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.security-header {
  background: linear-gradient(135deg, #2c6d3a 0%, #4caf6e 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.ip-hint {
  font-size: 0.8em;
  color: #666;
  direction: ltr;
  text-align: left;
  margin-top: 4px;
  padding-left: 4px;
}

.save-button {
  background: linear-gradient(0deg, rgba(255, 185, 26, 1) 0%, rgba(255, 185, 26, 0.8) 100%);
  color: #0d2c6d;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0 32px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .account-container {
    padding: 16px;
  }

  .primary-header,
  .secondary-header {
    font-size: 1.25rem;
  }
}

@media (max-width: 600px) {
  .save-button {
    width: 100%;
  }
}
</style>